import styles from './confirmationModal.module.scss';
import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import { useState } from 'react';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';

export default function ConfirmationModal(props) {
  const { t } = useTranslation();
  const { onAction, open, title, description, action = t('common.delete') } = props;

  const [loading, setLoading] = useState(false);

  const onConfirm = async () => {
    setLoading(true);
    await onAction(true);
    setLoading(false);
  };

  return (
    <Modal data-testid="ConfirmationModal" open={open} onClose={() => onAction(false)}>
      <div className={styles.confirmation_modal}>
        <h3>{title}</h3>
        <p>{description}</p>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            alignSelf: 'flex-end',
          }}>
          <Button
            data-testid="ConfirmationModalCancelButton"
            className={styles.confirmation_modal__cancel_btn}
            onClick={() => onAction(false)}
            size="small"
            variant="contained">
            {t('common.cancel')}
          </Button>
          <Button
            data-testid="ConfirmationModalConfirmButton"
            className={styles.confirmation_modal__confirm_btn}
            onClick={onConfirm}
            size="small"
            disabled={loading}
            variant="contained">
            {action}
          </Button>
        </Box>
      </div>
    </Modal>
  );
}
